
import { LoadState } from "../../constants/enums";
import { INITIAL_QUOTES, initialQuoteReqState } from "./quote.types";
import { createSlice } from "@reduxjs/toolkit";
import { fetchQuoteReq, fetchQuotesRequestList } from "./quoteActions";
import { APIError } from "../../constants/types";

export const quoteRequestSlice = createSlice({
  name: "quote",
  initialState: initialQuoteReqState,
  reducers: {
    clearQuoteRequestState: (state) => {
      return initialQuoteReqState;
    },
    clearQuote: (state) => {
      state.loading = LoadState.NotLoaded;
      state.quote = INITIAL_QUOTES;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchQuotesRequestList.pending, (state) => {
        state.loading = LoadState.InProgress;
        state.list = [];
      })
      .addCase(fetchQuotesRequestList.fulfilled, (state, action) => {
        state.loading = LoadState.Loaded;
        state.list = action.payload;
      })
      .addCase(fetchQuotesRequestList.rejected, (state, action) => {
        state.loading = LoadState.Failed;
        state.list = [];
      })
      .addCase(fetchQuoteReq.pending, (state) => {
        state.loading = LoadState.InProgress;
        state.quote = INITIAL_QUOTES;
      })
      .addCase(fetchQuoteReq.fulfilled, (state, action) => {
        state.loading = LoadState.Loaded;
        state.quote = action.payload;
      })
      .addCase(fetchQuoteReq.rejected, (state, action) => {
        state.loading = LoadState.Failed;
        state.error = (action.payload as APIError).message;
      });
  },
});

export const { clearQuoteRequestState, clearQuote } = quoteRequestSlice.actions;
export const quoteRequestReducer = quoteRequestSlice.reducer;
